import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { InstitutionRankingDetailResponseData } from "../../types/institution-ranking";

export const getData = async (
  id: string | undefined,
): Promise<InstitutionRankingDetailResponseData> => {
  const { data } = await api.get(`/institution-ranking/${id}`);

  return data;
};

export const useInstitutionRanking = (
  id: string | undefined,
): QueryObserverBaseResult<InstitutionRankingDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.institutionRanking(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
